import React, { useEffect, useState } from "react";
import logo from "./assets/fh-brundle-logo-CKb-fo13.png";

function getInitialTheme() {
  const savedTheme = window.localStorage.getItem("fhbrundle-payment-theme");
  return savedTheme === "dark" ? "dark" : "light";
}

export function BrandHeader({
  title = "Online payments",
  subtitle = "Secure F.H. Brundle services",
}) {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    window.localStorage.setItem("fhbrundle-payment-theme", theme);
  }, [theme]);

  return (
    <div className="brand-bar">
      <header className="site-header">
        <a
          className="brand"
          href="https://www.fhbrundle.co.uk"
          target="_blank"
          rel="noreferrer"
          aria-label="Visit the F.H. Brundle website"
        >
          <img
            className="brand__logo"
            src={logo}
            alt="F.H. Brundle — Serving the Trade Since 1889"
          />
        </a>

        <div className="header-actions">
          <div className="header-title">
            <strong>{title}</strong>
            <span>{subtitle}</span>
          </div>
          <button
            type="button"
            className="theme-toggle"
            onClick={() =>
              setTheme((currentTheme) =>
                currentTheme === "dark" ? "light" : "dark"
              )
            }
            aria-label={theme === "dark" ? "Use light mode" : "Use dark mode"}
          >
            {theme === "dark" ? "Light mode" : "Dark mode"}
          </button>
        </div>
      </header>
    </div>
  );
}

export function PageHero({
  eyebrow = "F.H. Brundle online services",
  title,
  description,
  children,
  compact = false,
  hideIntro = false,
}) {
  return (
    <section
      className={`payment-hero${compact ? " payment-hero--compact" : ""}${
        hideIntro ? " payment-hero--content-only" : ""
      }`}
    >
      {!hideIntro && (
        <div className="payment-hero__copy">
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
      )}
      {children && <div className="payment-hero__content">{children}</div>}
    </section>
  );
}
